import { LookupKeys } from '@ag-common-lib/public-api';
import {
  TextAlignment
} from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models/template-builder-alignment.model';

export enum CaptionPosition {
  none = 'none',
  above = 'above',
  below = 'below',
}

export const CaptionPositionMap = new Map([
  [CaptionPosition.none, 'None'],
  [CaptionPosition.above, 'Above'],
  [CaptionPosition.below, 'Below'],
]);

export const CAPTION_POSITION_LOOKUP = [CaptionPosition.none, CaptionPosition.above, CaptionPosition.below].map(
  value => {
    return { [LookupKeys.value]: value, [LookupKeys.description]: CaptionPositionMap.get(value) };
  },
);

export class CaptionOptions {
  alignment: TextAlignment = TextAlignment.start;
  wrapText: boolean = false;
  lineClamp: number = 1;

  constructor(
    public fontSize: number = 21,
    public color: string = 'inherit',
  ) {}
}
